<template>
  <v-expansion-panels v-model="isOpen" multiple flat>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-row
          align="center"
          justify="end"
          class="px-3 deep-purple--text lighten-3 font-weight-bold"
        >
          {{ $t('common.filter') }}
        </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row dense>
          <v-col cols="12" md="4">
            <v-select
              v-model="local.actionType"
              :items="actionTypeItems"
              :label="$t('supportRequests.filters.action_type')"
              clearable
              dense
              hide-details
              @change="emitChange"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model.number="local.schoolId"
              type="number"
              :label="$t('supportRequests.filters.school_id')"
              clearable
              dense
              hide-details
              @change="emitChange"
              @click:clear="onClear('schoolId')"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-menu v-model="fromMenu" :close-on-content-click="false" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="local.dateFrom"
                  :label="$t('supportRequests.filters.date_from')"
                  prepend-icon="mdi-calendar"
                  readonly
                  dense
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="onClear('dateFrom')"
                />
              </template>
              <v-date-picker
                v-model="local.dateFrom"
                @input="fromMenu = false; emitChange()"
              />
            </v-menu>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu v-model="toMenu" :close-on-content-click="false" min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="local.dateTo"
                  :label="$t('supportRequests.filters.date_to')"
                  prepend-icon="mdi-calendar"
                  readonly
                  dense
                  hide-details
                  clearable
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="onClear('dateTo')"
                />
              </template>
              <v-date-picker
                v-model="local.dateTo"
                :min="local.dateFrom"
                @input="toMenu = false; emitChange()"
              />
            </v-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="d-flex justify-end">
            <v-btn text small @click="reset">
              {{ $t('supportRequests.filters.clear') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { SupportActionType } from '@/constants/supportRequests';

export default {
  name: 'SupportRequestFilters',
  props: {
    value: {
      type: Object,
      default: () => ({
        actionType: null, schoolId: null, dateFrom: null, dateTo: null,
      }),
    },
  },
  data() {
    return {
      isOpen: [],
      fromMenu: false,
      toMenu: false,
      local: { ...this.value },
    };
  },
  watch: {
    // Sincroniza cuando el padre cambia el filtro desde afuera (ej. los chips
    // de conteo por tipo de acción), no solo cuando lo cambia este componente.
    value: {
      deep: true,
      handler(newValue) {
        this.local = { ...newValue };
      },
    },
  },
  computed: {
    actionTypeItems() {
      return [
        { text: this.$t('supportRequests.filters.all_action_types'), value: null },
        ...Object.values(SupportActionType).map((type) => ({
          text: this.$t(`supportRequests.action_types.${type}`),
          value: type,
        })),
      ];
    },
  },
  methods: {
    emitChange() {
      this.$emit('input', { ...this.local });
      this.$emit('search');
    },
    onClear(field) {
      this.local[field] = null;
      this.emitChange();
    },
    reset() {
      this.local = {
        actionType: null, schoolId: null, dateFrom: null, dateTo: null,
      };
      this.emitChange();
    },
  },
};
</script>
